export default [
  {
    path: '/search-order',
    name: 'search-order',
    component: () => import('@/views/pages/komship/search-order/List.vue'),
    meta: {
      resource: 'Komship - Order & Pickup',
      navActiveLink: 'search-order',
      action: 'manage',
    },
  },
  {
    path: '/search-order/detail/:id',
    name: 'search-order-detail',
    component: () => import('@/views/pages/komship/search-order/DetailOrder.vue'),
    meta: {
      resource: 'Komship - Order & Pickup',
      navActiveLink: 'search-order',
      action: 'manage',
    },
  },
  {
    path: '/tiket/detail/order/:id',
    name: 'tiket-detail-order',
    component: () => import('@/views/pages/tiket/DetailOrder.vue'),
    meta: {
      resource: 'Komship - Order & Pickup',
      navActiveLink: 'search-order',
      action: 'manage',
    },
  },
  {
    path: '/tiket/kolaborator/detail/order/:id',
    name: 'tiket-detail-order-collaborator',
    component: () => import('@/views/pages/tiket/detail-ticket-collaborator/detail-ticket-collaborator.vue'),
    meta: {
      resource: 'Komship - Order & Pickup',
      navActiveLink: 'search-order',
      action: 'manage',
    },
  },
]
